import React from 'react';
import mq from '../../../../commons/styles/mediaQueries';
import { useI18n } from '../../../../i18n';
import styled from '../../../../theme/styled';
import { TransactionStatusReason } from '../../../../../typings/transaction';

const StyledReason = styled.div`
  font-size: ${({ theme }) => theme.sizes.regular};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.colors.secondary};
  text-align: center;
  margin: 0 0 8px 0;

  ${mq.desktop} {
    margin: 8px 0;
    text-align: left;
  }
`;

interface StatusReasonProps {
  statusReason: TransactionStatusReason | undefined;
}

const statusReasonMapper: Record<TransactionStatusReason, string> = {
  ORDER_REJECTED: 'dlv_status_reason_order_rejected',
  ORDER_EXPIRED: 'dlv_status_reason_order_expired',
  CONTRACT_CANCELLED: 'dlv_status_reason_contract_cancelled',
  CONTRACT_EXPIRED: 'dlv_status_reason_contract_expired',
  PACKAGE_REJECTED: 'dlv_status_reason_package_rejected',
  SHIPMENT_EXPIRED: 'dlv_status_reason_shipment_expired',
};

const StatusReason: React.FC<StatusReasonProps> = ({ statusReason }) => {
  const i18n = useI18n();

  // check for null and undefined
  // eslint-disable-next-line eqeqeq
  if (statusReason == undefined) {
    return null;
  }

  return <StyledReason>{i18n`${statusReasonMapper[statusReason]}`}</StyledReason>;
};

export default StatusReason;
